module.exports = __webpack_public_path__ + "static/farm-to-pantry-2195c07578961255f336c03a24a51055.jpg";